import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput, FormSelect } from 'view/components/Form';

const SmsResponseFilters = ({
	filters,
	filterOptions,
	onFilterChange,
	onSearch,
	onReset,
}) => {
	const { control, handleSubmit, reset } = useForm({
		defaultValues: {
			search: filters.search || '',
			has_reply: filters.has_reply || 'all',
			signature_valid: filters.signature_valid || 'all',
			intent: filters.intent || 'all',
			date_from: filters.date_from || '',
			date_to: filters.date_to || '',
		},
		mode: 'onChange',
	});

	useEffect(() => {
		reset({
			search: filters.search || '',
			has_reply: filters.has_reply || 'all',
			signature_valid: filters.signature_valid || 'all',
			intent: filters.intent || 'all',
			date_from: filters.date_from || '',
			date_to: filters.date_to || '',
		});
	}, [filters, reset]);

	const onSubmitForm = (data) => {
		onSearch(data);
	};

	const handleReset = () => {
		reset({
			search: '',
			has_reply: 'all',
			signature_valid: 'all',
			intent: 'all',
			date_from: '',
			date_to: '',
		});
		onReset();
	};

	const hasReplyOptions = filterOptions?.has_reply?.length
		? filterOptions.has_reply
		: [
				{ value: 'all', label: 'All Replies' },
				{ value: 'yes', label: 'Has App Reply' },
				{ value: 'no', label: 'No App Reply' },
		  ];

	const signatureOptions = filterOptions?.signature_valid?.length
		? filterOptions.signature_valid
		: [
				{ value: 'all', label: 'All Signatures' },
				{ value: 'yes', label: 'Valid' },
				{ value: 'no', label: 'Invalid' },
		  ];

	const intentOptions = filterOptions?.intents?.length
		? filterOptions.intents
		: [
				{ value: 'all', label: 'All Intents' },
				{ value: 'ignore', label: 'Ignored' },
				{ value: 'resolve_bare', label: 'RESOLVE' },
				{ value: 'resolve_index', label: 'RESOLVE N' },
				{ value: 'resolve_all', label: 'RESOLVE ALL' },
				{ value: 'confirm_assumed', label: 'Confirm' },
				{ value: 'pick_alternative', label: 'Pick Alternative' },
				{ value: 'other', label: 'Other' },
		  ];

	return (
		<div className="card mb-4">
			<div className="card-header">
				<h6 className="mb-0">
					<i className="bi bi-funnel me-2" />
					Filters
				</h6>
			</div>
			<div className="card-body">
				<form onSubmit={handleSubmit(onSubmitForm)}>
					<div className="row g-3">
						<div className="col-md-4">
							<FormInput
								name="search"
								control={control}
								label="Search"
								placeholder="Phone, body, user..."
								helpText="Search by phone, message text, or user"
							/>
						</div>
						<div className="col-md-2">
							<FormSelect
								name="intent"
								control={control}
								label="Intent"
								options={intentOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-2">
							<FormSelect
								name="has_reply"
								control={control}
								label="App Reply"
								options={hasReplyOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-2">
							<FormSelect
								name="signature_valid"
								control={control}
								label="Signature"
								options={signatureOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-2">
							<FormInput
								name="date_from"
								control={control}
								type="date"
								label="Date From"
							/>
						</div>
						<div className="col-md-2">
							<FormInput
								name="date_to"
								control={control}
								type="date"
								label="Date To"
							/>
						</div>
					</div>
					<div className="d-flex gap-2 mt-3">
						<button type="submit" className="btn btn-primary">
							<i className="bi bi-search me-2" />
							Search
						</button>
						<button
							type="button"
							className="btn btn-secondary"
							onClick={handleReset}
						>
							<i className="bi bi-arrow-counterclockwise me-2" />
							Reset
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default SmsResponseFilters;
